import * as React from "react";
import { Box, Grid } from "@mui/material";
import { getAllEmployees } from "state/apis";
import moment from "moment";
import { formatAmount } from "utils/constants";
import "./index.css";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const TerminatedEmployees = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const [data, setData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const reportRef = React.useRef();

    React.useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await getAllEmployees(10000, 0, "", true);
            const terminated = (res?.data || []).filter((emp) => !emp.isActive);
            setData(terminated);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    if (isLoading) {
        return (
            <Box m="1.5rem 2.5rem">
                <h1>Loading...</h1>
            </Box>
        );
    }

    const handlePrint = () => {
        const input = reportRef.current;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("l", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;
            let heightLeft = imgHeight;
            let position = margin;
            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;
            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }
            pdf.save(`terminated-employees-report.pdf`);
        });
    };

    let totalLeaveSalary = 0;
    let totalEndOfService = 0;

    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" mb={1}>
                <button className="download-btn" onClick={handlePrint}>
                    Download PDF
                </button>
            </Box>
            <div className="report-container" ref={reportRef}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={{ fontWeight: "bold", padding: "0px", marginTop: "10px" }}>
                        TERMINATED EMPLOYEES REPORT
                    </span>
                    <span style={{ fontWeight: "bold", padding: "0px" }}>
                        Printed on: {moment().format("DD MMM YYYY")}
                    </span>
                </div>
                <p style={{ fontWeight: "bold", paddingBottom: "10px" }}>{propertyName}</p>
                <table
                    border="1"
                    cellPadding="5"
                    cellSpacing="0"
                    style={{
                        position: "relative",
                        zIndex: 1,
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={{ textAlign: "center" }}>SL</th>
                            <th style={{ textAlign: "center" }}>EMP ID</th>
                            <th style={{ textAlign: "center" }}>EMPLOYEE NAME</th>
                            <th style={{ textAlign: "center" }}>DESIGNATION</th>
                            <th style={{ textAlign: "center" }}>JOINING DATE</th>
                            <th style={{ textAlign: "center" }}>TERMINATION DATE</th>
                            <th style={{ textAlign: "center" }}>SALARY</th>
                            <th style={{ textAlign: "center" }}>LEAVE SALARY</th>
                            <th style={{ textAlign: "center" }}>END OF SERVICE</th>
                            <th style={{ textAlign: "center" }}>REMARKS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => {
                                totalLeaveSalary += Number(row.leaveSalary) || 0;
                                totalEndOfService += Number(row.endOfService) || 0;
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.empId}</td>
                                        <td>{row.employeeName}</td>
                                        <td>{row.designation}</td>
                                        <td>
                                            {row.joiningDate
                                                ? moment(row.joiningDate).format("DD/MM/YYYY")
                                                : "-"}
                                        </td>
                                        <td>
                                            {row.terminationDate
                                                ? moment(row.terminationDate).format("DD/MM/YYYY")
                                                : "-"}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(row.salary) || 0)}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(row.leaveSalary) || 0)}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(row.endOfService) || 0)}
                                        </td>
                                        <td>{row.terminationRemarks || "-"}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center" }}>
                                    No terminated employees found
                                </td>
                            </tr>
                        )}
                        {data.length > 0 && (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "right", fontWeight: "bold" }}>
                                    Total
                                </td>
                                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                    {formatAmount(totalLeaveSalary)}
                                </td>
                                <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                    {formatAmount(totalEndOfService)}
                                </td>
                                <td></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Box>
    );
};

export default TerminatedEmployees;
